import React from "react";
import "../../Styles/cartao.css";

/**
 * Cartão Premium — Clínica Catarino
 */
const Cartao = ({
  icone: Icone,
  titulo = "Sem título",
  descricao,
  badgeText,
  children,
  onClick,
  className = "",
}) => {
  const Tag = onClick ? "button" : "article";

  return (
    <Tag
      className={`
        cartao
        ${onClick ? "cartao--clickable" : ""}
        ${className}
      `.trim()}
      onClick={onClick}
      type={onClick ? "button" : undefined}
      aria-label={
        onClick
          ? `Abrir detalhes do serviço: ${titulo}`
          : undefined
      }
    >
      {/* Glow decorativo */}
      <div className="cartao__glow"></div>

      {/* =========================
          HEADER
      ========================= */}
      <header className="cartao__header">
        {Icone && (
          <div
            className="cartao__icon-wrapper"
            aria-hidden="true"
          >
            <Icone
              size={32}
              strokeWidth={1.6}
            />
          </div>
        )}

        <div className="cartao__header-content">
          <h3 className="cartao__title">
            {titulo}
          </h3>

          {badgeText && (
            <span className="cartao__badge">
              {badgeText}
            </span>
          )}
        </div>
      </header>

      {/* =========================
          BODY
      ========================= */}
      {descricao && (
        <div className="cartao__body">
          <p className="cartao__description">
            {descricao}
          </p>
        </div>
      )}

      {/* =========================
          FOOTER
      ========================= */}
      {children && (
        <footer className="cartao__footer">
          {children}
        </footer>
      )}
    </Tag>
  );
};

export default Cartao;